// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__b1MOY","footer":"ModalUpdate_footer__1L5cG"};